import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Employee } from '../models/employee.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';


@Injectable()
export class EmployeeService{
   public url: string;
   public user_id: number;

   constructor(
     public _http: Http,
     public variableService:VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.variableService.getCookie('user_id'));
   }

   getEmployees()
   {
     return this._http.get(this.url+'employees/'+this.user_id).map(res => res.json());
   }

   getEmployee()
   {
     return "getEmployee from service";
   }

   addEmployee(employee: Employee)
   {
     let json = JSON.stringify(employee);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-employee/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateEmployee(id:number,pEmployee: Employee)
   {
     let json = JSON.stringify(pEmployee);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-employee/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteEmployee(id:number)
   {
     return this._http.get(this.url+'delete-employee/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/employee.service.ts